var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCloudNotif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.042 11.302a3.2 3.2 0 0 1-2.03.72c-1.79 0-3.25-1.46-3.25-3.25 0-.89.36-1.7.96-2.29v-.01c.59-.59 1.4-.96 2.29-.96 1.8 0 3.26 1.46 3.26 3.25 0 1.02-.47 1.94-1.23 2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.352 20.219H5.972c-2.74-.2-3.96-2.31-3.96-4.19 0-1.68.97-3.54 3.1-4.06-.93-3.58.85-6.08 2.93-7.27 2.06-1.17 4.96-1.36 7.14.25-.19.14-.36.29-.53.46l-.43.45v.06c-.62.81-.96 1.8-.96 2.84 0 2.62 2.14 4.75 4.76 4.75 1.08 0 2.13-.37 2.95-1.04.15-.12.3-.25.43-.39.99 2.08.85 4.84-1.22 6.65-1.05.96-2.4 1.49-3.83 1.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCloudNotif);
export default __webpack_public_path__ + "static/media/vuesax-bold-cloud-notif.3eb40252020debc079273706df56b243.svg";
export { ForwardRef as ReactComponent };